import { citySchema } from "@redotech/redo-model/geographic-unit";
import * as z from "zod/v4";

export const getCities = {
  name: "getCities" as const,
  input: z.object({ countryCode: z.string(), stateCode: z.string() }),
  output: z.array(citySchema),
};
